export default "__VITE_ASSET__CMsM$Idd__"